import React, { useEffect, useRef, useState } from 'react';
import { Chart as ChartJS, BubbleController, LinearScale, PointElement, Tooltip, Legend, Title } from 'chart.js';
import { Bubble } from 'react-chartjs-2';
import { Line } from 'react-chartjs-2';

ChartJS.register(BubbleController, LinearScale, PointElement, Tooltip, Legend, Title);

const ScatterChart = ({ rfmResponse }) => {
    const chartRef = useRef();

    const [data, setData] = useState(null);
    const [options, setOptions] = useState(null);

    useEffect(() => {
        if (!rfmResponse || rfmResponse.length === 0) {
            console.warn("No data received for rendering chart.");
            return;
        }

        const segmentData = {
            Champions: [],
            Loyalists: [],
            Potential: [],
            New: [],
            "At Risk": [],
            Hibernating: [],
            Others: []
        };

        let minX = Infinity, maxX = -Infinity;
        let minY = Infinity, maxY = -Infinity;

        rfmResponse.forEach((data) => {
            const point = {
                x: data.recency_days,
                y: data.order_count,
                r: data.total_spent
                // r: 50

            };

            // Update min/max values dynamically
            if (point.x < minX) minX = point.x;
            if (point.x > maxX) maxX = point.x;
            if (point.y < minY) minY = point.y;
            if (point.y > maxY) maxY = point.y;

            if (data.segment === "Champions") {
                // if(segmentData.Champions.length < 5){
                    segmentData.Champions.push(point)
                // }
            }
            else if (data.segment === "Loyalist") segmentData.Loyalists.push(point);
            else if (data.segment === "Potential"){
                // if(segmentData.Potential.length < 5){
                    segmentData.Potential.push(point)
                // }
            }
            else if (data.segment === "New") segmentData.New.push(point);
            else if (data.segment === "At Risk") segmentData["At Risk"].push(point);
            else if (data.segment === "Hibernating") segmentData.Hibernating.push(point);
            else {
                // if(segmentData.Others.length < 5){
                    segmentData.Others.push(point)
                // }
            }
            // else {
            //     if (segmentData.Others.length < 10) {
            //         segmentData.Others.push(point);
            //     }
            // }
        });

        // Add some padding to min/max values for better visualization
        minX = Math.max(0, minX - 10);
        maxX = maxX + 10;
        minY = Math.max(0, minY - 10);
        maxY = maxY + 10;

        const chartData = {
            datasets: Object.keys(segmentData).map(segment => ({
                label: segment,
                data: segmentData[segment],
                backgroundColor: getSegmentColor(segment),
                borderColor: getSegmentBorderColor(segment)
            }))
        };

        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: true },
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            return [
                                `Cluster: ${context.dataset.label}`,
                                `Recency: ${Math.round(context.parsed.x)}`,
                                `Frequency: ${Math.round(context.parsed.y)}`,
                                `Value: $${(Math.round(context.raw.r)).toFixed(2)}`
                            ];
                        }
                    }
                }
            },
            scales: {
                x: {
                    title: {
                        display: true,
                        text: 'Recency',
                        font: { weight: 'bold' }
                    },
                    beginAtZero: false,
                    min: minX,
                    max: maxX
                },
                y: {
                    title: {
                        display: true,
                        text: 'Frequency',
                        font: { weight: 'bold' }
                    },
                    beginAtZero: false,
                    min: minX,
                    max: maxX
                }
            }
        };

        setData(chartData);
        setOptions(chartOptions);
    }, [rfmResponse]);

    const getSegmentColor = (segment) => {
        const colors = {
            Champions: 'rgba(34, 197, 94, 0.7)',
            Loyalists: 'rgba(59, 130, 246, 0.7)',
            Potential: 'rgba(249, 115, 22, 0.7)',
            New: 'rgba(168, 85, 247, 0.7)',
            "At Risk": 'rgba(239, 68, 68, 0.7)',
            Hibernating: 'rgba(107, 114, 128, 0.7)',
            Others: 'rgba(17, 85, 185, 0.7)'
        };
        return colors[segment] || 'rgba(0, 0, 0, 0.7)';
    };

    const getSegmentBorderColor = (segment) => {
        const borderColors = {
            Champions: 'rgba(34, 197, 94, 1)',
            Loyalists: 'rgba(59, 130, 246, 1)',
            Potential: 'rgba(249, 115, 22, 1)',
            New: 'rgba(168, 85, 247, 1)',
            "At Risk": 'rgba(239, 68, 68, 1)',
            Hibernating: 'rgba(107, 114, 128, 1)',
            Others: 'rgb(31, 88, 175)'
        };
        return borderColors[segment] || 'rgba(0, 0, 0, 1)';
    };

    return (
        <div style={{ height: '500px', width: '100%' }}>
            {
                console.log(data,"jjjjjjjjjj")
            }
            {data && options ? <Bubble ref={chartRef} data={data} options={options} /> : <p>Loading chart...</p>}
            {/* {data && options ? <Line ref={chartRef} data={data} options={options} /> : <p>Loading chart...</p>} */}
        </div>
    );
};

export default ScatterChart;
